import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TooltipModule } from '../../../directives/tooltip/tooltip.module';
import { ButtonModule } from '../../forms/button/button.module';
import { PopoverComponent } from './popover.component';

@NgModule({
  imports: [CommonModule, ButtonModule, TooltipModule],
  declarations: [PopoverComponent],
  exports: [PopoverComponent]
})
export class PopoverModule {}
